import { Network } from '@capacitor/network'
import { onlineManager } from '@tanstack/react-query'

import { platform } from './platform'

export async function wireOnlineManager() {
  if (!platform.isNative()) return
  const status = await Network.getStatus()
  onlineManager.setOnline(status.connected)
  Network.addListener('networkStatusChange', (s) => {
    onlineManager.setOnline(s.connected)
  })
}
